import type { ReactNode } from 'react'
import { Children, useContext } from 'react'

import { createSharedContext } from '@twistopayments/design-system/utils'

export type ListVariant = 'medium' | 'small'

/**
 * Context
 */

type ListContext = {
  index: number
  variant: ListVariant
}

const Context = createSharedContext<ListContext | null>('components/molecules/list/list.context#0', null)

/**
 * Provider
 */

type Props = {
  children: ReactNode
  variant: ListVariant
}

export const ListProvider = ({ children, variant }: Props) => (
  <>
    {Children.map(children, (child, index) => (
      <Context.Provider value={{ index, variant }}>{child}</Context.Provider>
    ))}
  </>
)

/**
 * Hook
 */

export const useList = () => {
  const context = useContext(Context)

  if (!context) {
    throw new Error('useList must be used within a ListProvider')
  }

  return context
}
